/* Realm sparkle: fills every [data-realm-sparkle] field with twinkling glints
   and an occasional shooting star. Styles live in realm.css. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var COLOURS = ['#f3c96b', '#f2e9d8', '#ffffff', '#f0a6ff'];
  var rand = function (min, max) { return min + Math.random() * (max - min); };

  function addGlints(field, count) {
    for (var i = 0; i < count; i++) {
      var star = document.createElement('span');
      star.className = 'realm-sparkle__star';
      star.style.left = rand(3, 97) + '%';
      star.style.top = rand(4, 92) + '%';
      star.style.setProperty('--s', rand(10, 26).toFixed(0) + 'px');
      star.style.setProperty('--c', COLOURS[Math.floor(Math.random() * COLOURS.length)]);
      star.style.setProperty('--dur', rand(4, 9).toFixed(1) + 's');
      star.style.setProperty('--delay', (-rand(0, 9)).toFixed(1) + 's');
      field.appendChild(star);
    }
  }

  function shoot(field) {
    var w = field.clientWidth, h = field.clientHeight;
    if (!w || !h || document.hidden) return;
    var fromLeft = Math.random() < 0.5;
    var angle = rand(14, 32);
    var rotation = fromLeft ? angle : 180 - angle;
    var dist = w * rand(0.45, 0.7);
    var el = document.createElement('span');
    el.className = 'realm-sparkle__shoot';
    el.style.left = (fromLeft ? rand(0.05, 0.4) : rand(0.6, 0.95)) * w + 'px';
    el.style.top = rand(0.06, 0.4) * h + 'px';
    field.appendChild(el);
    var anim = el.animate([
      { transform: 'rotate(' + rotation + 'deg) translateX(0)', opacity: 0 },
      { opacity: 1, offset: 0.15 },
      { opacity: 1, offset: 0.7 },
      { transform: 'rotate(' + rotation + 'deg) translateX(' + dist + 'px)', opacity: 0 }
    ], { duration: rand(900, 1300), easing: 'cubic-bezier(0.3, 0, 0.6, 1)' });
    anim.onfinish = function () { el.remove(); };
  }

  function start(field) {
    addGlints(field, window.innerWidth < 750 ? 8 : 16);
    (function schedule(first) {
      setTimeout(function () { shoot(field); schedule(false); }, first ? 2500 : rand(7000, 14000));
    })(true);
  }

  function init() {
    document.querySelectorAll('[data-realm-sparkle]').forEach(start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
